import instance from "./axios";
import {
  GlassLoaderPostPayload,
  GlassType,
  MaterialGlassType,
} from "../types/GlassLoaderTypes";

export const fetchAllGlassTypes = async (
  stationId?: number
): Promise<GlassType[]> => {
  const response = await instance.get("/v1.0/Material/GetAllGlassTypes");
  const data: GlassType[] = response.data;
  if (stationId == null) return data;
  return data
    .filter((g) => g.standardGlass === 1 || g.standardGlass === stationId)
    .map(({ id, name, standardGlass }) => ({ id, name, standardGlass }));
};

export const fetchLastMaterialGlassByStationId = async (
  stationId: number
): Promise<MaterialGlassType[]> => {
  const response = await instance.get(
    `/v1.0/Material/GetLastMaterilglassByStationId?stationId=${stationId}&num=15`
  );
  return response.data;
};

export const postGlassType = async (data: GlassLoaderPostPayload) => {
  const response = await instance.post("/v1.0/Material/AddMaterialGlass", data);
  return response.data;
};
